// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-72cfebc0] .vl-text--alt {
  font-size: 1.5rem;
  color: #666;
  margin-bottom: 0;
  font-weight: 400;
}
.info-cell[data-v-72cfebc0]:not(:first-child) {
  padding-left: 10px;
}
.padding-left[data-v-72cfebc0] {
  padding-left: 1rem;
}
.info-cell[data-v-72cfebc0] {
  max-width: 100rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
